import { AppRouteProps } from "@mzara/component";
import { ExportContainer } from "./container/ExportContainer";

export const DataExportRoutes: Array<AppRouteProps> = [
    {
        title: "Harea.Data.Export.Title",
        path: "export",
        element: <ExportContainer />,
    },
];
